module.exports = __webpack_public_path__ + "img/logo-symbol.36e2ba9e.svg";